import React from "react";
import Reveal from "@/components/Reveal";
import { useLang } from "@/i18n";

/** Short page-specific intro: gives each route its own content and its own H1. */
export const PageLead = ({ pageKey, title, tone = "light", testId }) => {
  const { t } = useLang();
  const lead = t.leads[pageKey];
  const dark = tone === "dark";

  return (
    <section
      data-testid={testId || `lead-${pageKey}`}
      className={`px-6 md:px-12 lg:px-20 pt-16 md:pt-20 pb-14 md:pb-20 ${dark ? "bg-[#3B2523]" : "bg-[#F5F1E8]"}`}
    >
      <div className="max-w-3xl">
        <Reveal>
          <p
            className={`uppercase tracking-[0.25em] text-xs font-semibold ${
              dark ? "text-[#F4D35E]" : "text-[#8C6B2F]"
            }`}
          >
            {lead.eyebrow}
          </p>
        </Reveal>
        <Reveal delay={0.05}>
          <h1
            className={`font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mt-5 leading-[1.02] ${
              dark ? "text-[#F5F1E8]" : "text-[#3B2523]"
            }`}
          >
            {title}
          </h1>
        </Reveal>
        <Reveal delay={0.1}>
          <p
            className={`text-base md:text-lg mt-6 leading-relaxed ${
              dark ? "text-[#E6D9B6]/70" : "text-[#3B2523]/70"
            }`}
          >
            {lead.text}
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default PageLead;
